import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

function dm_c_11_people_slider() {
  const sections = document.querySelectorAll('section.c-11-people-slider');

  sections.forEach((section) => {
    const viewport = section.querySelector('.swiper');
    if (!viewport) return;

    // Swiper structure
    let wrapper = viewport.querySelector('.swiper-wrapper');
    let slides = Array.from(viewport.querySelectorAll('.slide'));

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      slides.forEach((el) => el.classList.add('swiper-slide'));
      viewport.replaceChildren(wrapper);
      slides.forEach((el) => wrapper.appendChild(el));
    } else {
      slides.forEach((el) => el.classList.add('swiper-slide'));
    }

    // Scope controls
    const prevButtons = section.querySelectorAll('.swiper-btn.prev');
    const nextButtons = section.querySelectorAll('.swiper-btn.next');

    // pagination element (created once if needed)
    let paginationEl = viewport.querySelector('.swiper-pagination');
    if (!paginationEl) {
      paginationEl = document.createElement('div');
      paginationEl.className = 'swiper-pagination';
      viewport.appendChild(paginationEl);
    }

    // breakpoint: under lg (show pagination)
    const mq = '(max-width: 991.98px)';
    let swiper = null;
    let lastIsMobile = window.matchMedia(mq).matches;
    const prevHandlers = new Map();
    const nextHandlers = new Map();
    let resizeTimer = null;

    function addButtonListeners() {
      prevButtons.forEach((btn) => {
        if (btn === prevButtons[0]) return; // primary nav already wired by Swiper
        const handler = (e) => { e.preventDefault(); if (swiper) swiper.slidePrev(); };
        btn.addEventListener('click', handler);
        prevHandlers.set(btn, handler);
      });
      nextButtons.forEach((btn) => {
        if (btn === nextButtons[0]) return;
        const handler = (e) => { e.preventDefault(); if (swiper) swiper.slideNext(); };
        btn.addEventListener('click', handler);
        nextHandlers.set(btn, handler);
      });
    }

    function removeButtonListeners() {
      prevHandlers.forEach((handler, btn) => btn.removeEventListener('click', handler));
      nextHandlers.forEach((handler, btn) => btn.removeEventListener('click', handler));
      prevHandlers.clear();
      nextHandlers.clear();
    }

    function initSwiper() {
      if (swiper) return;
      const usePagination = window.matchMedia(mq).matches;

      const modules = [Navigation];
      if (usePagination) modules.push(Pagination);

      const config = {
        modules,
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: false,
        speed: 600,
        navigation: {
          prevEl: prevButtons[0] || null,
          nextEl: nextButtons[0] || null
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 4 },
        },
      };

      if (usePagination) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      try {
        swiper = new Swiper(viewport, config);
        addButtonListeners();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Swiper init failed:', err);
      }
    }

    function destroySwiper() {
      if (!swiper) return;
      removeButtonListeners();
      try {
        swiper.destroy(true, true);
      } catch (err) {
        // ignore destroy errors
      }
      swiper = null;
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const isMobile = window.matchMedia(mq).matches;
        if (isMobile === lastIsMobile) return;
        lastIsMobile = isMobile;
        destroySwiper();
        initSwiper();
      }, 120);
    }

    // initial
    initSwiper();
    window.addEventListener('resize', onResize);

    // cleanup if section removed
    const mo = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        destroySwiper();
        window.removeEventListener('resize', onResize);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
}

export { dm_c_11_people_slider };
